export function formatNumber(n){
  try{ return Number(n).toLocaleString('ru-RU'); }catch(e){return n}
}
export function formatDate(dt){
  if(!dt) return '';
  const d = new Date(dt);
  return d.toLocaleDateString('ru-RU',{day:'2-digit',month:'2-digit'});
}
export function formatDateTime(dt){
  if(!dt) return '';
  const d = new Date(dt);
  return d.toLocaleString('ru-RU');
}

// Утилиты
export function escapeHtml(str) {
  if (!str) return '';
  return str.replace(/[&<>"']/g, function (m) {
    switch (m) {
      case '&': return '&amp;';
      case '<': return '&lt;';
      case '>': return '&gt;';
      case '"': return '&quot;';
      case "'": return '&#39;';
      default: return m;
    }
  });
}

/**
 * Заменяет все ссылки в тексте на <a href="...">Ссылка</a>
 * - поддерживает https?:// и www.
 * - возвращает безопасную HTML-строку, готовую для v-html
 */
export function linkifyAndSanitize(text) {
  if (!text) return '';

  // сначала экранируем весь текст (чтобы избежать XSS)
  const escaped = escapeHtml(text);

  // Регекс на URL: захватывает https?://... и www....
  const urlRegex = /\b(?:https?:\/\/|www\.)[^\s<>"']+[^\s<>"'.,;:!?()]/gi;

  const replaced = escaped.replace(urlRegex, (rawUrl) => {
    // rawUrl уже экранирован в escaped (например, амперсанды и < заменены),
    // но здесь rawUrl будет 'экраннированной' последовательностью — безопасно работать с ней.
    // Для href нам нужно оригинальное (неэкранированное) значение — восстановим:
    // (в нашем случае safeHref строим на основе rawUrl, подставляя протокол)
    let href = rawUrl;

    // Если ссылка начиналась с &lt; (редкие случаи) — декодируем сущности минимум для протокола.
    // Но проще: если начинается с 'www.' (в escaped тоже 'www.'), добавляем https://
    if (/^www\./i.test(href)) {
      href = 'https://' + href;
    }

    // Доп. защита: допускаем только http или https
    if (!/^https?:\/\//i.test(href)) {
      // не заменяем, оставляем как текст (в escaped он безопасен)
      return rawUrl;
    }

    // Убираем нежелательные завершающие знаки (точки/запятые и т.п.), которые часто попадают в конец предложения
    href = href.replace(/[.,;:!?)+]+$/g, '');

    // Кодируем URI для href
    try { href = encodeURI(href); } catch (e) { /* если не удалось — оставим как есть */ }

    // Возвращаем якорь с безопасными атрибутами
    return `<a style="color: var(--blue-0); text-decoration: none" href="${href}" target="_blank" rel="noopener noreferrer">Ссылка</a>`;
  });

  return replaced;
}
